import { IProjectTeamMember } from "./types";

// Backend can return null for FullName/RoleDisplayName, so every field is
// coalesced to "" before lowercasing/searching.
export const matchesTeamMemberSearch = (
  member: IProjectTeamMember,
  query: string
): boolean => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return true;
  }

  const searchableFields = [
    member.FullName,
    member.Email,
    member.RoleDisplayName
  ];

  return searchableFields.some((field) =>
    (field ?? "").toLowerCase().includes(normalizedQuery)
  );
};
